var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('path',{attrs:{"d":"M3 6H21V8H3V6ZM3 11H21V13H3V11ZM3 16H21V18H3V16Z"}}),(_vm.title !== '')?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }